import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
var ICON_SIZE = 24;
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-jtcrtv-0"
})(["display:flex;flex-flow:column;"]);
export var IconBlock = styled.div.withConfig({
  displayName: "partials__IconBlock",
  componentId: "sc-jtcrtv-1"
})(["svg{display:block;width:", "px;height:", "px;}"], ICON_SIZE, ICON_SIZE);
export var Label = styled.div.withConfig({
  displayName: "partials__Label",
  componentId: "sc-jtcrtv-2"
})(["margin-left:8px;color:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.font;
}, getFont(0));
export var RowBlock = styled.div.withConfig({
  displayName: "partials__RowBlock",
  componentId: "sc-jtcrtv-3"
})(["display:flex;align-items:center;justify-content:space-between;", " ", " ", ""], function (_ref2) {
  var isLastRow = _ref2.isLastRow;
  return !isLastRow && css(["border-bottom:1px solid ", ";"], function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.ui;
  });
}, function (_ref4) {
  var isLastRow = _ref4.isLastRow,
    lastIsSummary = _ref4.lastIsSummary;
  return lastIsSummary && isLastRow && css(["margin-bottom:9px;"]);
}, function (_ref5) {
  var lastIsSummary = _ref5.lastIsSummary;
  return lastIsSummary && css([":last-child{padding:0 8px;border:1px solid ", ";border-radius:", ";margin-top:auto;margin-left:-8px;margin-right:-8px;background-color:", ";}"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.ui;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.borderRadius;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.uiLL;
  });
});
var columnStyles = css(["flex-grow:1;&:first-child{flex-grow:0;flex-shrink:1;}font-weight:", ";text-align:", ";"], function (_ref9) {
  var fontWeight = _ref9.fontWeight;
  return fontWeight || 500;
}, function (_ref10) {
  var textAlign = _ref10.textAlign;
  return textAlign;
});
export var Column = styled.div.withConfig({
  displayName: "partials__Column",
  componentId: "sc-jtcrtv-4"
})(["padding:9px 0;", ""], columnStyles);
export var HeaderColumn = styled(Column).withConfig({
  displayName: "partials__HeaderColumn",
  componentId: "sc-jtcrtv-5"
})(["font-weight:400;"]);
export var CellWithIcon = styled(Column).withConfig({
  displayName: "partials__CellWithIcon",
  componentId: "sc-jtcrtv-6"
})(["display:flex;align-items:center;margin-left:auto;margin-right:12px;font-weight:400;", " ", " span{display:flex;align-items:center;}svg{width:24px;height:24px;margin-right:7px;color:", ";}"], fontSmoothing, getFont(0), function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.fontL;
});
export var BarBlock = styled.div.withConfig({
  displayName: "partials__BarBlock",
  componentId: "sc-jtcrtv-7"
})(["display:flex;align-items:center;width:30%;"]);
export var Bar = styled.div.withConfig({
  displayName: "partials__Bar",
  componentId: "sc-jtcrtv-8"
})(["width:", "%;height:9px;border-radius:8px;background-color:", ";"], function (_ref12) {
  var value = _ref12.value;
  return value;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.secondaryM;
});